import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {setUser} from '../../actions/user';
import authenticationService from '../../services/authentication/AuthenticationService';
import organisationService from '../../services/organisation/OrganisationService';
import {captureError} from '../../utils/log';
import {displayOrganisationRegistrationHelp} from '../../utils/organisation';
import GlobalDashboardView from './GlobalDashboardView';

function GlobalDashboardContainer() {
  const user = useSelector(state => state.user);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const history = useHistory();

  React.useEffect(() => {
    async function updateUserOrganisations(userId) {
      try {
        const searchParams = {
          query: '',
          userId,
          country: null,
          postCode: null
        };
        const {organisations: userOrganisations} = await organisationService.search(searchParams, 0, 1000);
        dispatch(setUser({...user, userOrganisations}));
        setLoading(false);
      } catch (error) {
        captureError('Error while getting user organisations', error);
      }
    }

    if (!authenticationService.roles().isBackOffice()) {
      updateUserOrganisations(user.id);
    } else {
      setLoading(false);
    }
  }, []);

  React.useEffect(() => {
    if (displayOrganisationRegistrationHelp(user.userOrganisations)) {
      history.push('/register-organisation-help');
    }
  }, [user]);

  return (
    <GlobalDashboardView loading={loading}/>
  );
}

export default GlobalDashboardContainer;
